import { lazy } from 'react';

export const LabelSearchPicker = lazy(() => import('./LabelSearchPicker'));
